namespace GeniuzPOS.AdvPromo {
    export enum ApprovePromoSelect {
        ApproveFgSelect = 0,
        ApproveFgSelect1 = 1
    }
    Serenity.Decorators.registerEnumType(ApprovePromoSelect, 'GeniuzPOS.AdvPromo.ApprovePromoSelect');
}
